import quickFetch from 'quick-fetch';
function getEarlyRequest({
  key,
  defaultRequestFn,
  forceUseDefault = false
}) {
  if (!key && !defaultRequestFn) {
    throw new Error('Key and request fallback are required.');
  }
  const earlyRequest = quickFetch.getRequestStateByName(key);
  if (earlyRequest && !forceUseDefault) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(key);
      });
      earlyRequest.onError(() => {
        defaultRequestFn().then(resolve).catch(reject);
        quickFetch.removeEarlyRequest(key);
      });
    });
  } else {
    return defaultRequestFn();
  }
}
export default getEarlyRequest;